export const basePath = 'https://bae-silver-www.totalenergies.be';
export const environment = {
  production: false,
  includeDynamicByDefault: true,
  showChat: true,
  envName: 'bae-silver',
  dynatraceScriptUrl: 'https://js-cdn.dynatrace.com/jstag/164ae1b51de/bf99649qxv/5feb77f611da6cab_complete.js',
  BACKEND_URL: 'https://public.besimulatorpgsilver.alzp.tgscloud.net',
  PRODUCT_CATALOG_URL: 'https://public.beproductcatalogsilver.alzp.tgscloud.net',
  CONTACT_EMAIL_B2B: 'welcome.pro@totalenergies.be',
  CONTACT_EMAIL_B2C: 'support@totalenergies.be',
  languageAssetsPath: './assets/i18n/',
  B2B_OLREG_NL: `${basePath}/nl/professioneel/producten-en-diensten/my-business/ons-energieaanbod/inschrijving`,
  B2B_OLREG_FR: `${basePath}/fr/professionnels/produits-et-services/my-business/notre-offre-energie/inscription`,
  B2C_OLREG_NL: `${basePath}/nl/particulieren/producten-en-diensten/my-home/elektriciteit-en-aardgas/aanbod-electriciteit-en-aardgas/inschrijving/contact`,
  B2C_OLREG_FR: `${basePath}/fr/particuliers/produits-et-services/my-home/electricite-et-gaz/offre-electricite-et-gaz/inscription/contact`,
  B2C_OLREG_EN: `${basePath}/en/individuals/products-and-services/my-home/electricity-and-gas/electricity-and-gas-offer/registration/contact`,
  WEBSITE_B2B_NL: `${basePath}/nl/professioneel`,
  WEBSITE_B2B_FR: `${basePath}/fr/professionnels`,
  WEBSITE_B2C_NL: `${basePath}/nl/particulieren`,
  WEBSITE_B2C_FR: `${basePath}/fr/particuliers`,
  googleTagManager: 'GTM-WNSPC3',
  googleTagManagerTotalEnergies: 'GTM-56ZW5TK4',
};
